import { useTranslation } from 'react-i18next';

const planKeys = ['self', 'individual', 'groupSmall', 'groupLarge'];

const PricesPage = () => {
  const { t } = useTranslation('dashboard');

  return (
    <div className="page-card prices-page">
      <div className="page-card-header">
        <div>
          <h1>{t('prices.heading.title')}</h1>
          <p className="page-description">{t('prices.heading.description')}</p>
        </div>
      </div>

      <div className="pricing-grid">
        {planKeys.map((key) => (
          <article key={key} className="pricing-card">
            <h2 className="pricing-card__title">{t(`prices.plans.${key}.title`)}</h2>
            <p className="pricing-card__price">{t(`prices.plans.${key}.price`)}</p>
            <p className="pricing-card__features-title">{t('prices.featuresTitle')}</p>
            <ul className="pricing-card__features-list">
              {Array.isArray(t(`prices.plans.${key}.features`, { returnObjects: true })) &&
                t(`prices.plans.${key}.features`, { returnObjects: true }).map((feature) => (
                <li key={`${key}-${feature}`} className="pricing-card__feature-item">
                  {feature}
                </li>
              ))}
            </ul>
            <p className="pricing-card__subtitle">{t(`prices.plans.${key}.subtitle`)}</p>
          </article>
        ))}
      </div>
    </div>
  );
};

export default PricesPage;
